import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AppBar, Menu, MenuItem, Toolbar, Typography } from '@mui/material'
import { Home as HomeIcon } from '@mui/icons-material'
import { makeStyles } from '@mui/styles'
import _ from 'lodash'

import { useOAuth } from 'hooks/useOAuth'
import { useHover } from 'hooks/useHover'

const useStyles = makeStyles((theme) => {
  const spacing = (val, ...args) => {
    if (typeof theme.spacing === 'function') return theme.spacing(val, ...args)
    return (val * 8) + 'px'
  }
  return {
    icon: {
      marginRight: spacing(2)
    }
  }
})

const Header = () => {
  const classes = useStyles()
  const navigate = useNavigate()
  const [menuAnchorEl, setMenuAnchorEl] = useState(null)
  const [signOutHoverRef, signOutHovered] = useHover()
  const auth = useOAuth()
  const signIn = auth.signIn
  const signOut = auth.signOut

  const anchorMenu = e => setMenuAnchorEl(e.currentTarget)
  const unanchorMenu = () => setMenuAnchorEl(null)

  return (
    <>
      <AppBar position='relative'>
        <Toolbar style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div
            style={{ display: 'flex', cursor: 'pointer', alignItems: 'center', flexShrink: 0 }}
            onClick={() => navigate('/')}
          >
            <HomeIcon className={classes.icon} style={{ color: '#ffffff' }} />
            <Typography variant='h6' color='inherit' noWrap>
              Sonowz Sandbox
            </Typography>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {auth.user
              ? (
                <div
                  style={{ cursor: 'pointer' }}
                  onClick={signOut}
                  ref={signOutHoverRef}
                >
                  <Typography variant='h6' color='inherit' noWrap>
                    {signOutHovered ? 'Sign Out' : auth.user.email}
                  </Typography>
                </div>
                )
              : (
                <div
                  style={{ cursor: 'pointer' }}
                  onClick={signIn}
                >
                  <Typography variant='h6' color='inherit' noWrap>Sign In</Typography>
                </div>
                )}
            <div
              className={classes.clickPointer}
              style={{ width: '160px', marginLeft: '20px' }}
              aria-controls='menu'
              aria-haspopup='true'
              onClick={anchorMenu}
              onMouseEnter={anchorMenu}
            >
              <Typography variant='h6' color='inherit' align='right' noWrap>
                Other Pages
              </Typography>
            </div>
          </div>
          <Menu
            id='menu'
            anchorEl={menuAnchorEl}
            open={!_.isNil(menuAnchorEl)}
            keepMounted
            onClose={unanchorMenu}
          >
            <MenuItem onClick={() => { window.location.href = '/jobs' }}>Job Archiver</MenuItem>
            <MenuItem onClick={() => { unanchorMenu(); navigate('/djmax') }}>DJMAX Picker</MenuItem>
            <MenuItem onClick={() => { window.location.href = '/factorio' }}>Factorio Timelapses</MenuItem>
            <MenuItem onClick={() => { window.location.href = '/raytrace' }}>Raytrace Demo</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
    </>
  )
}

export default Header
